import React, { useMemo } from "react";
import { Copy } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { showInfo, showWarning } from "@/store/errorStore";
import { buildReceiptText, copyText } from "./orderHelpers";

/** Comanda em texto puro (sem acento) para colar no app da impressora térmica */
const ReceiptTextDialog = ({ open, onOpenChange, order }) => {
  const text = useMemo(() => (order ? buildReceiptText(order) : ""), [order]);

  if (!order) return null;

  const handleCopy = async () => {
    try {
      await copyText(text);
      onOpenChange(false);
      showInfo("Texto da comanda copiado para a área de transferência.", "Copiado");
    } catch (error) {
      showWarning(
        "Não foi possível copiar automaticamente. Selecione o texto e use Ctrl+C (ou Cmd+C no Mac).",
      );
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg p-4 sm:p-6">
        <DialogHeader className="text-left">
          <DialogTitle className="flex items-center gap-2 font-display text-primary">
            <Copy className="h-5 w-5" />
            Comanda do pedido #{order.code}
          </DialogTitle>
          <DialogDescription>
            Texto sem acentos, com 32 colunas, compatível com impressora térmica de 58 mm.
          </DialogDescription>
        </DialogHeader>
        <textarea
          value={text}
          readOnly
          aria-label="Texto da comanda"
          onFocus={(e) => e.target.select()}
          className="h-80 w-full resize-none whitespace-pre rounded-lg border border-border bg-surface p-3 font-mono text-xs text-foreground focus:border-primary focus:outline-none focus:ring-[3px] focus:ring-brand-pistachio/25"
        />
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Fechar
          </Button>
          <Button onClick={handleCopy} className="hover:bg-brand-dark">
            <Copy className="mr-2 h-4 w-4" />
            Copiar texto
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReceiptTextDialog;
